module.exports = __webpack_public_path__ + "img/ygbx.026a70a3.png";